/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-28 17:58:17
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { FormLayout, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderCheckbox } from 'src/components/views/common/forms/render-checkbox';
import { RenderSelect } from 'src/components/views/common/forms/render-select';
import { RenderSelectMultiple } from 'src/components/views/common/forms/render-select-multiple';
import { buildShowVariantImageBasedOnOption } from 'src/helpers/filter-settings-helper';
import {
  FILTER_SETTINGS_PAGINATION_TYPES,
  FILTER_SETTINGS_SORTING_TYPES,
  FILTER_SETTINGS_OUT_OF_STOCK__DISPLAY_OPTION
} from 'src/constants/filter-settings';

type Props = {
  i18n: Object,
  themeSetupV2: boolean,
  optionsList: Object,
  appLanguage: string
};
type ComposedProps = Props & WithI18nProps;

class ProductListTab extends Component<ComposedProps> {
  render() {
    const { i18n, themeSetupV2, optionsList, appLanguage } = this.props;

    const paginationTypes = FILTER_SETTINGS_PAGINATION_TYPES.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const sortingType = FILTER_SETTINGS_SORTING_TYPES.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });
    const outOfStockDisplayOption = FILTER_SETTINGS_OUT_OF_STOCK__DISPLAY_OPTION.map(function (
      type
    ) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });

    const showVariantImageBasedOnOption = buildShowVariantImageBasedOnOption(
      optionsList,
      appLanguage,
      i18n
    );

    return (
      <FormLayout>
        <Stack distribution="fill">
          <FormLayout>
            <Field
              name="displaySetting.showLoading"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field1_Label')}
            />
            <Field
              name="displaySetting.activeScrollToTop"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field2_Label')}
            />
          </FormLayout>
          <FormLayout>
            <Field
              name="displaySetting.sortingAvailableFirst"
              component={RenderCheckbox}
              label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field3_Label')}
              tooltip={i18n.translate(
                'AdminHTML.FilterSettings.Display.productListTab_Field3_Tooltip'
              )}
            />
            {themeSetupV2 && (
              <Field
                name="displaySetting.useCanonicalUrl"
                component={RenderCheckbox}
                label={i18n.translate(
                  'AdminHTML.FilterSettings.Display.productListTab_FieldCanonicalURL_Label'
                )}
                tooltip={
                  <span>
                    {i18n.translate(
                      'AdminHTML.FilterSettings.Display.productListTab_FieldCanonicalURL_Tooltip',
                      {
                        nt_link1: (
                          <i>https://www.myshopify.com/collections/t-shirts/products/blue-tee</i>
                        ),
                        nt_link2: <i>https://www.myshopify.com/products/blue-tee</i>
                      }
                    )}
                  </span>
                }
              />
            )}
          </FormLayout>
        </Stack>
        <Field
          name="displaySetting.outOfStockDisplayOption"
          component={RenderSelect}
          label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field4_Label')}
          options={outOfStockDisplayOption}
        />
        {themeSetupV2 && (
          <Field
            name="displaySetting.showVariantImageBasedOn"
            component={RenderSelect}
            label={i18n.translate(
              'AdminHTML.FilterSettings.Display.productListTab_FieldShowVariantImageBasedOn_Label'
            )}
            tooltip={i18n.translate(
              'AdminHTML.FilterSettings.Display.productListTab_FieldShowVariantImageBasedOn_Tooltip'
            )}
            options={showVariantImageBasedOnOption}
          />
        )}
        <div>
          <Field
            name="displaySetting.paginationType"
            component={RenderSelect}
            label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field5_Label')}
            options={paginationTypes}
          />
          <p style={{ marginTop: '4px' }}>
            {i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field5_Note1')}{' '}
            <b>{i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field5_Note2')}</b>
          </p>
        </div>
        {!themeSetupV2 && (
          <Field
            name="displaySetting.customSortingList"
            component={RenderSelectMultiple}
            label={i18n.translate('AdminHTML.FilterSettings.Display.productListTab_Field6_Label')}
            options={sortingType}
            placeholder={i18n.translate(
              'AdminHTML.FilterSettings.Display.productListTab_Field6_Placeholder'
            )}
            tooltip={i18n.translate(
              'AdminHTML.FilterSettings.Display.productListTab_Field6_Tooltip'
            )}
          />
        )}
      </FormLayout>
    );
  }
}
export default withI18n()(ProductListTab);
